export default function () {
    var counter = 0;

    $('.button-longtask[href^="javascript"]').on("click", function (e) {
        $('.button-longtask[href^="javascript"]').children(".loader").remove();

        var attr = $(this).attr("onclick");

        if (attr === undefined) {
            if ($(this).children(".loader").length === 0) {
                $(this).append('<span class="loader"></span>');
            }

            if (counter > 0) {
                e.preventDefault();
            }

            counter = 1;
        }
    });
}